import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TituloReceberPerspectivaSelectModule } from '../../perspectiva';
import { TituloReceberFilterModule } from '../../filter';
import { TituloReceberVisualizacaoModule } from '../../visualizacao';
import { TituloReceberTableModule } from '../table';
import { TituloReceberDashboardModule } from '../dashboard';
import { IntegrationTituloReceberSharedModule } from '../../../configuracoes/integration/titulo-receber';
import { TituloReceberIntegracaoErpImportModule } from '../../integracoes/erp/import';
import { TituloReceberClienteTableModule } from '../../cliente/view/table';
import { TituloReceberClienteViewModalModule } from '../../cliente/view/modal';
import { TituloReceberFormModalModule } from '../../form/modal';

import { TituloReceberViewContainerComponent } from './titulo-receber-view-container.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberPerspectivaSelectModule,
        TituloReceberFilterModule,
        TituloReceberVisualizacaoModule,
        TituloReceberTableModule,
        TituloReceberDashboardModule,
        IntegrationTituloReceberSharedModule,
        TituloReceberIntegracaoErpImportModule,
        TituloReceberClienteTableModule,
        TituloReceberClienteViewModalModule,
        TituloReceberFormModalModule
    ],
    declarations: [
        TituloReceberViewContainerComponent
    ],
    exports: [
        TituloReceberViewContainerComponent
    ]
})
export class TituloReceberViewContainerModule { }
